import React from 'react';
import './EventSingle.css';

import { Lightbox, PageSidebar, PageTitle, TeamItem } from '../../../components';
import { FaArrowRight } from 'react-icons/fa';
import { useLocation } from 'react-router-dom';

const EventSingle = () => { 

  // Get the event data from the router state
  const location = useLocation();  
  const eventSingle = location.state; 

  return (
    <>
      {/* Page Title */}
      <PageTitle title={'Event Single'} page={'Event Single'} />

      <section className='event-single page-single'>

        <div className='event-info page-info'>

          {/* Event Image */}
          <div className='image'>
            <img src={eventSingle.image} alt={eventSingle.title} />
          </div>

          <div className='content'>

            {/* Event Heading */}
            <h3 className='main-heading'>{eventSingle.title}</h3>

            {/* Event Description */}
            {eventSingle.paragraphs.map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}

            {/* Event Image Gallery */}
            <Lightbox images={eventSingle.gallery} className={'service'} />

            {/* Event Agenda Section */}
            <div className='sub-section'>
              <h3 className='sub-heading'>Event Agenda</h3>

              {/* Agenda Introduction */}
              <p>{eventSingle.agenda.intro}</p>
              
              {/* List of Agenda Points */}
              <ul>
                {eventSingle.agenda.points.map((point, index) => (
                  <li key={index}>
                    <FaArrowRight className='icon' />
                    {point}
                  </li>
                ))}
              </ul>
            </div>

            {/* Event Speakers Section */}
            <div className='team sub-section'>
              <h3 className='sub-heading'>Event Speakers:</h3>

              {/* Speaker List */}
              <div className='box-container'>
                {eventSingle.speakers.map((speaker) => (
                  <TeamItem
                    key={speaker.id}
                    image={speaker.image}
                    name={speaker.name}
                    title={speaker.title}
                    accounts={speaker.accounts}
                    team={speaker}
                  />
                ))}
              </div>
            </div> 

            {/* Event Venue Map */}
            <div className="event-map sub-section">
              <h3 className="sub-heading">Event Venue:</h3>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d924234.6303368191!2d66.59494515823903!3d25.193389461148573!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3eb33e06651d4bbf%3A0x9cf92f44555a0c23!2sKarachi%2C%20Karachi%20City%2C%20Sindh%2C%20Pakistan!5e0!3m2!1sen!2s!4v1645287442276!5m2!1sen!2s"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                title="Event Venue Map"
              ></iframe>
            </div>

          </div> 
        
        </div> 

        {/* Sidebar with Event Details */}
        <PageSidebar
          heading={'Event'}
          details={eventSingle.details}
          button={{ link: 'contact-us', title: 'Register Now' }}
        />

      </section>

    </> 
  );
}

export default EventSingle;